import {
  MODELER_FORM_ENDPOINT,
  RUNTIME_FORM_ENDPOINT,
} from "../constants/endpoints";
import { ResponseProps, request } from "./request";

export const fetchModelerForm = async (
  id: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem("gatewayURL")}${MODELER_FORM_ENDPOINT}/${id}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false };
};

export const postModelerForm = async (body: {
  name: string;
  elasticPush: string;
  components: { display: "string"; components: [] };
  id?: string;
  type: string;
}): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: ResponseProps = (await request.post(
    `${sessionStorage.getItem("gatewayURL")}${MODELER_FORM_ENDPOINT}`,
    body
  )) as ResponseProps;

  if (r.success) {
    return { success: r.success, data: r.data, message: r.message };
  }

  return { success: false, data: r.data, message: r.message };
};

export const postRuntimeModelerForm = async (body: {
  name: string;
  components: { display: "string"; components: [] };
  id: string;
  type: string;
  version: string;
}): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: ResponseProps = (await request.post(
    `${sessionStorage.getItem("gatewayURL")}${RUNTIME_FORM_ENDPOINT}`,
    body
  )) as ResponseProps;

  if (r.success) {
    return { success: r.success, data: r.data, message: r.message };
  }

  return { success: false, data: r.data, message: r.message };
};
